import { FlightplanId } from "@poscon/shared-types";
import { ComponentType } from "react";
import { useRootSelector } from "~/redux/hooks";
import { flightplanSelector } from "~/redux/slices/aircraftSlice";
import { Asel } from "~/redux/slices/eramTempStateSlice";
import { EramAselMenu } from "~/types/eramView";
import {
  AltitudeMenu,
  HeadingMenu,
  FreeTextMenu,
  HoldMenu,
  PreviousRouteMenu,
  RouteMenu,
  SpeedMenu,
  XResMenu,
  EramAircraftMenuProps,
} from "./menus/AircraftMenu";
import { PoMenu } from "./prompts/PoMenu";
import { cpdlcMiniMOView, cpdlcPidView, cpdlcTocHeldView } from "@poscon/shared-frontend";
import { CpdlcMiniMOPrompt } from "./views/CpdlcMiniMO";
import { CpdlcPidMenuPrompt } from "./views/CpdlcPidMenu";
import { CpdlcTocHeldPrompt } from "./prompts/CpdlcTocHeldPrompt";

const flightplanMenuMap: Record<EramAselMenu, ComponentType<EramAircraftMenuProps> | null> = {
  ALTITUDE_MENU: AltitudeMenu,
  CANCEL_HOLD_MENU: null,
  CHANGE_DEST_MENU: null,
  HEADING_MENU: HeadingMenu,
  FREETEXT_MENU: FreeTextMenu,
  HOLD_MENU: HoldMenu,
  PO_MENU: PoMenu,
  PREV_ROUTE_MENU: PreviousRouteMenu,
  ROUTE_MENU: RouteMenu,
  SPEED_MENU: SpeedMenu,
  X_RES_MENU: XResMenu,
  [cpdlcMiniMOView]: CpdlcMiniMOPrompt,
  [cpdlcPidView]: CpdlcPidMenuPrompt,
  [cpdlcTocHeldView]: CpdlcTocHeldPrompt,
};

type AselComponentProps = {
  asel: Asel;
};

export const AselComponent = ({ asel }: AselComponentProps) => {
  const fp = useRootSelector((state) => flightplanSelector(state, asel.fpId));

  const Component = flightplanMenuMap[asel.menu];

  return fp && Component ? <Component key={asel.fpId} fp={fp} /> : null;
};
